module.exports = __webpack_public_path__ + "img/profil-fabrice-jouaud.1a8500c.jpeg";